<template>
  <div>
    <img src="../assets/img/Outbound-banner.png" width="100%" alt="">
    <div class="OutboundM">
      <img src="../assets/img/Outbound-img1.png" alt="">
      <p><i class="iconfont icon-dianhua4"></i>
        <a href="tel:18958188698">18958188698</a></p>
    </div>
    <Modular obj="Outbound" name="modular2"></Modular>
    <Modular obj="Outbound" name="modular3"></Modular>
    <div class="outBoundList">
      <h3>{{outBoundObj1.title}}</h3>
      <ul>
        <li v-for="(item,index) in outBoundObj1.ullist" :key="index">
          <h4>{{item.title}}</h4>
          <p>{{item.p}}</p>
        </li>
      </ul>
      <img src="../assets/img/Outbound-img4.png" alt="">
    </div>
    <div class="outBoundList">
      <h3>{{outBoundObj2.title}}</h3>
      <ul>
        <li v-for="(item,index) in outBoundObj2.ullist" :key="index">
          <h4>{{item.title}}</h4>
          <p>{{item.p}}</p>
        </li>
      </ul>
    </div>
    <Modular obj="Outbound" name="modular6"></Modular>
    <News></News>
  </div>
</template>
<script>
import Modular from '../components/Modular'
import News from '../components/MNews'
import Text from '../utils/text'
export default {
  name:'Outbound',
  components: {
    Modular,
    News
  },
  data(){
    return {
      news:[],
      outBoundObj1:[],
      outBoundObj2:[]
    }
  },
  created(){
    this.outBoundObj1 = Text.websiteText["Outbound"].modular4
    this.outBoundObj2 = Text.websiteText["Outbound"].modular5
  },
  methods:{

  }
}
</script>

<style lang="scss">
  .OutboundM{
    position: relative;
    img{
      margin-top:50px;  
      display: block;
      width:100%;
    }
    p{
      position: absolute;
      width:205px;
      height:47px;
      line-height:47px;
      background:#f07cbd;
      border-radius:10px;
      color:#fff;
      font-size:24px;
      bottom:94px;
      left:50%;
      transform: translate(-50%,0);
      padding-left:10px;  
      a,visited{
        color:#fff;
        text-decoration: none;
      }
      i{
        margin-top:20px;
      }
    }
  }
  .outBoundList{
    margin:0 27px;
    h3{
      margin-top:30px;
      width:236px;
      height:84px;
      background:url('../assets/img/outbTBg.png') no-repeat;
      color:#fff;
      font-size:36px;
      padding-left:56px;
      box-sizing:border-box;
      padding-top:2px;
      background-size:cover;
    }
    li{
      margin-bottom:40px;
      h4{
        font-size:30px;
        color:#333;
        line-height:80px;
        font-weight:bold;
      }
      p{
        font-size:28px;
        line-height:48px;
        color:#666;
      }
    }
    img{
      display:block;
      width:100%;
      margin:0 auto;
    }
  }
</style>
